import Fetch from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchAnnouncements: ({ category }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_ANNOUNCEMENTS,
    readStatus,
    { category },
  ),
};
